import Faqs from "@/components/landing/home/Faqs";
import Banner from "@/components/landing/homeEight/Banner";
import CallAction from "@/components/landing/homeEight/CallAction";
import HowItsWork from "@/components/landing/homeEight/HowItsWork";
import StartEarning from "@/components/landing/homeEight/StartEarning";
import WhyChooseUs from "@/components/landing/homeEight/WhyChooseUs";

export default function HomeEight() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* How Its Work section */}
      <HowItsWork />

      {/* Why Choose Us section */}
      <WhyChooseUs
        sectionTitle="Why freelancers enable OracleMarket alerts"
        sectionDescription="Spend less time refreshing dashboards—let the platform surface what needs your attention."
        itemLabels={[
          "Instant funding notices",
          "FX & crypto triggers",
          "Device & login watchlist",
          "Digest & quiet hours",
        ]}
      />

      {/* Start Earning section */}
      <StartEarning />

      {/* Call Action section */}
      <CallAction />

      {/* Faqs section */}
      <Faqs
        sectionTitle="Alerts & notifications FAQs"
        sectionDescription="Learn how OracleMarket reaches you—and how to stay in control."
      />
    </>
  );
}
